import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../helper/httpService';
import { Constants } from '../helper/constants';

@Injectable()
export class PolicyService {
  private policyServiceUrl = Constants.serverUrl + 'api/policy/';

  constructor(public http: HttpService) {}

  getPolicyGroups(): Observable<any> {
    return this.http.Get(this.policyServiceUrl + 'getPolicyGroups');
  }

  getPolicyGroupDetails(policyGroupId: number): Observable<any> {
    return this.http.Get(this.policyServiceUrl + 'getPolicyGroupDetails' + '/' + policyGroupId);
  }

  getPolicyAnswers(): Observable<any> {
    return this.http.Get(this.policyServiceUrl + 'getPolicyAnswers');
  }

  savePolicyAnswers(answersList: any): Observable<any> {
    const data = JSON.stringify(answersList);
    return this.http.Post(this.policyServiceUrl + 'savePolicyAnswers', data);
  }
}
